import { ElementRef, Injectable } from '@angular/core';
import { environment as shellEnvironment } from 'src/environments/environment'; 
import { loadMFE } from 'src/app/MFE/loadMFE';

export interface MfeLoadOptions {
  configKey: string;         
  tagName: string;           
  scriptPath: string;        
  containerRef: ElementRef; 
}

@Injectable({
  providedIn: 'root' 
})

export class MfeLoaderService {

  private loadedScripts = new Set<string>();

  constructor() { }

  async load(options: MfeLoadOptions): Promise<void> {
    const { configKey, tagName, scriptPath, containerRef } = options;
    const containerEl = containerRef.nativeElement as HTMLElement;

    (window as any)[configKey] = shellEnvironment;

    try {
      if (!this.loadedScripts.has(scriptPath)) {
        await loadMFE(scriptPath);
        this.loadedScripts.add(scriptPath); 

      }
      if (customElements.get(tagName)) {
        if (!containerEl.querySelector(tagName)) {
          const mfeElement = document.createElement(tagName);
          containerEl.innerHTML = ''; 
          containerEl.appendChild(mfeElement);
        } else {
        }
      } else {
         delete (window as any)[configKey];
      }
    } catch (error) {
      delete (window as any)[configKey];

    }
  }

  cleanupConfig(configKey: string): void {
    delete (window as any)[configKey];
  }
}